export default __webpack_public_path__ + "static/media/hht1_ep17_timeline_q02_b.af1cf060.png";